const Header = () => {
  return (
    <div className="text-center">
      <h1 className="text-blue-500 text-3xl font-bold">T-Shirt Designer</h1>
      <h3 className="text-gray-500">Design your T-Shirt by yourself ! </h3>
    </div>
  );
};

export default Header;
